import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

import cloneDeep from 'lodash/cloneDeep';
import defaultFields from './fields.json';
import axios from 'axios';
import injected from '../injected';
import pica from 'pica/dist/pica.min.js';

var defaultActiveFields = Object.keys(defaultFields);

export var getFields = function getFields(task) {
  var filterFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultActiveFields;

  var fields = cloneDeep(defaultFields);
  fields.dueDate.isActive = !!task.dueDate;
  fields['when.date'].isActive = task.completed === 0;
  fields.estimatedTime.isActive = task.estimatedTime > 0;
  var finalFields = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = filterFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (!fields[key]) {
        continue;
      }
      finalFields.push(fields[key]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return finalFields;
};

var IMAGE_FILE_TYPE = 1;
var MAX_THUMBNAIL_SIZE = 400;

var computeNewDimensions = function computeNewDimensions(img) {
  var width = img.width;
  var height = img.height;
  if (width > height && width > MAX_THUMBNAIL_SIZE) {
    return [MAX_THUMBNAIL_SIZE, Math.floor(MAX_THUMBNAIL_SIZE * height / width)];
  } else if (height > width && height > MAX_THUMBNAIL_SIZE) {
    return [Math.floor(MAX_THUMBNAIL_SIZE * width / height), MAX_THUMBNAIL_SIZE];
  }
  return [width, height];
};

var resizeImage = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
    var fileType;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fileType = file.type;
            // The quickfix adopted right now keeps the thumbnails the same size as the original size.
            // If we don't do that, pica turns the gif file into a simple png file, and thus loses the thumbnail animation.
            // We should find a way to resize gifs.

            if (!(fileType === 'image/gif')) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt('return', file);

          case 3:
            return _context2.abrupt('return', new Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onload = function () {
                var img = new Image();
                img.src = reader.result;
                img.onload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _computeNewDimensions, _computeNewDimensions2, width, height, canvas, result, blob, _file;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _computeNewDimensions = computeNewDimensions(img), _computeNewDimensions2 = _slicedToArray(_computeNewDimensions, 2), width = _computeNewDimensions2[0], height = _computeNewDimensions2[1];
                          canvas = document.createElement('canvas');

                          canvas.width = width;
                          canvas.height = height;
                          _context.next = 7;
                          return pica().resize(img, canvas, { alpha: true });

                        case 7:
                          result = _context.sent;
                          _context.next = 10;
                          return pica().toBlob(result, 'image/png', 1);

                        case 10:
                          blob = _context.sent;
                          _file = new File([blob], 'pasted-image-thumbnail.png', {
                            type: 'image/png',
                            lastModified: Date.now()
                          });

                          resolve(_file);
                          _context.next = 18;
                          break;

                        case 15:
                          _context.prev = 15;
                          _context.t0 = _context['catch'](0);

                          reject(_context.t0);

                        case 18:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[0, 15]]);
                }));
                img.onerror = function (e) {
                  console.error('img error: ', e);
                };
              };

              reader.readAsDataURL(file);
            }));

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function resizeImage(_x2) {
    return _ref.apply(this, arguments);
  };
}();

export var getThumbnail = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
    var resized;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return resizeImage(file);

          case 3:
            resized = _context3.sent;
            return _context3.abrupt('return', resized);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3['catch'](0);
            throw _context3.t0;

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[0, 7]]);
  }));

  return function getThumbnail(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var uploadImage = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5, uploadsUrls, onUploadProgress) {
    var file = _ref5.file,
        thumbnail = _ref5.thumbnail;
    var fileUploadURL, thumbnailUploadURL, fileId, rest, userId;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            fileUploadURL = uploadsUrls.fileUploadURL, thumbnailUploadURL = uploadsUrls.thumbnailUploadURL, fileId = uploadsUrls.fileId, rest = _objectWithoutProperties(uploadsUrls, ['fileUploadURL', 'thumbnailUploadURL', 'fileId']);
            _context4.next = 4;
            return Promise.all([axios.put(fileUploadURL, file, { onUploadProgress: onUploadProgress }), axios.put(thumbnailUploadURL, thumbnail)]);

          case 4:
            userId = injected.user.id;
            return _context4.abrupt('return', _extends({}, rest, {
              fileId: fileId,
              uploadTime: new Date(),
              fileName: file.name || 'uploaded-image',
              fileType: IMAGE_FILE_TYPE,
              userId: userId
            }));

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4['catch'](0);
            throw _context4.t0;

          case 11:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[0, 8]]);
  }));

  return function uploadImage(_x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
export { uploadImage };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/utils.js
// module id = 292
// module chunks = 0